import { render, staticRenderFns } from "./cancellationPolicy.vue?vue&type=template&id=c6b7696c&"
import script from "./cancellationPolicy.vue?vue&type=script&lang=js&"
export * from "./cancellationPolicy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c6b7696c')) {
      api.createRecord('c6b7696c', component.options)
    } else {
      api.reload('c6b7696c', component.options)
    }
    module.hot.accept("./cancellationPolicy.vue?vue&type=template&id=c6b7696c&", function () {
      api.rerender('c6b7696c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2LMIX710iBt7z/JS/cancellationPolicy.vue"
export default component.exports